(function () {
  // 1. Pack Switcher Functionality
  function switchPackPresets(packKey) {
    if (!packKey) return;
    const keyStr = String(packKey).trim();

    const presetGroups = document.querySelectorAll('[data-preset-group]');
    presetGroups.forEach(function (group) {
      const groupKey = String(group.getAttribute('data-pack-key')).trim();

      if (groupKey === keyStr) {
        group.style.setProperty('display', 'contents', 'important');
      } else {
        group.style.setProperty('display', 'none', 'important');
      }
    });
  }

  // 2. Click Handler for Packs & Swatches
  document.addEventListener('click', function (e) {
    // Top Pack Option Click (10-Pack, 6-Pack, 3-Pack)
    const packBtn = e.target.closest('[data-pack-option]');
    if (packBtn) {
      const wrapper = packBtn.closest('.pack-selector');
      if (wrapper) {
        wrapper.querySelectorAll('[data-pack-option]').forEach(function (btn) {
          btn.classList.remove('pack-option--active');
        });
      }
      packBtn.classList.add('pack-option--active');

      const packKey = packBtn.getAttribute('data-pack-key') || packBtn.dataset.packKey;
      switchPackPresets(packKey);
      return;
    }

    // Color Swatch / Preset Click
    const swatchBtn = e.target.closest('[data-color-pack-option]');
    if (swatchBtn) {
      const group = swatchBtn.closest('[data-color-pack-group]');
      if (group) {
        group.querySelectorAll('[data-color-pack-option]').forEach(function (el) {
          el.classList.remove('color-pack-option--active');
        });
        swatchBtn.classList.add('color-pack-option--active');
      }

      if (swatchBtn.dataset.swatchType === 'preset' && swatchBtn.dataset.url) {
        window.location.href = swatchBtn.dataset.url;
      }
    }
  });

  // 3. Init on Page Load
  function init() {
    const activePackBtn = document.querySelector('[data-pack-option].pack-option--active');
    if (activePackBtn) {
      const initialKey = activePackBtn.getAttribute('data-pack-key') || activePackBtn.dataset.packKey;
      switchPackPresets(initialKey);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();